var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"ActBaseBottom"},[(_vm.showShareBtn)?_c('div',{staticClass:"shareBtn"},[_c('div',{staticClass:"default act-text-stroke",on:{"click":function($event){return _vm.$emit('lightup', 'share')}}},[_vm._v("呼朋唤友")])]):_vm._e(),_vm._v(" "+_vm._s(_vm.configInfo.disclaimer || "本次活动最终解释权归主办方远洋集团。")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }